import { useForm } from "react-hook-form";
import PageTitle from "../../layouts/PageTitle";
import { useDispatch, useSelector } from "react-redux";
import { ContextApi } from "../../../store/ContextApi";
import { useContext, useEffect, useState } from "react";
import { getCouponsFunc } from "../../../store/custom-actions/coupons-actions/GetCouponsSlicer";
import { toast } from "react-toastify";
import { Button } from "react-bootstrap";
import { useNavigate, useParams } from "react-router-dom";
import SpinnerLoading from "../../components/spinner-loading/SpinnerLoading";
import { getSingleCouponFunc } from "../../../store/custom-actions/coupons-actions/GetSingleCouponSlicer";
import EmptyData from "../../components/empty-data/EmptyData";
import { updateCouponFunc } from "../../../store/custom-actions/coupons-actions/UpdateCouponSlicer";
import { useTranslation } from "react-i18next";

export default function UpdateCouponFrom() {
  const { t } = useTranslation();
  const { couponId } = useParams();
  const {
    register,
    reset,
    formState: { errors },
    handleSubmit,
    setValue,
  } = useForm();
  const { loading: getSingleCouponLoading, data: singleCouponData } =
    useSelector((state) => state.getSingleCouponSlicer);
  const { loading: updateCouponLoading } = useSelector(
    (state) => state.updateCouponSlicer
  );
  const contextApi = useContext(ContextApi);
  const coupons_API_URL = `${process.env.REACT_APP_VERSEL_API}/api/dashboard/coupons`;
  const singleCoupon_API_URL = `${process.env.REACT_APP_VERSEL_API}/api/dashboard/coupons/${couponId}`;
  const dispatch = useDispatch();
  const nivigate = useNavigate();
  const [coupon, setCoupon] = useState({});

  useEffect(() => {
    const getCoupon = async () => {
      try {
        dispatch(getSingleCouponFunc(singleCoupon_API_URL));
      } catch (error) {
        console.log(error);
      }
    };
    getCoupon();
  }, []);
  useEffect(() => {
    singleCouponData && setCoupon(singleCouponData);
    if (singleCouponData) {
      setValue("code", singleCouponData.code);
      setValue("discount", singleCouponData.discount);
      setValue("count_used", singleCouponData.count_used);
      setValue("type", singleCouponData.type);
      setValue("start_date", singleCouponData.start_date);
      setValue("end_date", singleCouponData.end_date);
    }
  }, [singleCouponData]);
  const handleSubmitData = (data) => {
    if (data.start_date > data.end_date) {
      toast.error(t(`end date must be more than start date!`), {
        position: "top-right",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
      });
    } else {
      dispatch(
        updateCouponFunc({ api: singleCoupon_API_URL, data: { ...data } })
      ).then((result) => {
        if (result.payload.success === true) {
          const successMessage = result.payload.message;
          dispatch(getCouponsFunc(coupons_API_URL));
          reset();
          nivigate("/coupons");
          toast.success(`${t(successMessage)}!`, {
            position: "top-right",
            autoClose: 5000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
          });
        }
      });
    }
  };

  return (
    <>
      <PageTitle
        motherMenu={t("Dashboard")}
        activeMenu={t("Update") + " " + t("Coupon")}
      />
      {getSingleCouponLoading ? (
        <SpinnerLoading />
      ) : singleCouponData ? (
        <div className="col-12">
          <div className="card">
            <div className="card-body">
              <form
                id="update-coupon-form"
                onSubmit={handleSubmit((data) => {
                  handleSubmitData(data);
                })}
              >
                <div className="row">
                  <div className="form-group mb-3 col-sm-12 col-md-6">
                    <label>{t("Code")}</label>
                    {errors.code?.message && (
                      <p className="text-red-600">{t(errors.code?.message)}</p>
                    )}
                    <input
                      {...register("code", {
                        required: t("Feild is required"),
                      })}
                      type="text"
                      className="form-control"
                    />
                  </div>
                  <div className="form-group mb-3 col-sm-12 col-md-6">
                    <label>{t("Discount")}</label>
                    {errors.discount?.message && (
                      <p className="text-red-600">
                        {t(errors.discount?.message)}
                      </p>
                    )}
                    <input
                      {...register("discount", {
                        required: t("Feild is required"),
                      })}
                      type="number"
                      min={0}
                      className="form-control"
                    />
                  </div>
                </div>
                <div className="row">
                  <div className="form-group mb-3 col-sm-12 col-md-6">
                    <label>{t("Usage limit")}</label>
                    {errors.count_used?.message && (
                      <p className="text-red-600">
                        {t(errors.count_used?.message)}
                      </p>
                    )}
                    <input
                      {...register("count_used", {
                        required: t("Feild is required"),
                      })}
                      type="number"
                      min={0}
                      className="form-control"
                    />
                  </div>
                  <div className="form-group mb-3 col-sm-12 col-md-6">
                    <label>{t("Discount type")}</label>
                    {errors.type?.message && (
                      <p className="text-red-600">{t(errors.type?.message)}</p>
                    )}
                    <select
                      className="form-control col-sm-12"
                      {...register("type", {
                        required: t("Feild is required"),
                      })}
                    >
                      <option value="fixed">{t("Fixed")}</option>
                      <option value="percentage">{t("Percentage")}</option>
                    </select>
                  </div>
                </div>
                <div className="row">
                  <div className="form-group mb-3 col-sm-12 col-md-6">
                    <label>{t("From")}:</label>
                    {errors.start_date?.message && (
                      <p className="text-red-600">
                        {t(errors.start_date?.message)}
                      </p>
                    )}
                    <input
                      {...register("start_date", {
                        required: t("Feild is required"),
                      })}
                      type="date"
                      className="form-control"
                    />
                  </div>
                  <div className="form-group mb-3 col-sm-12 col-md-6">
                    <label>{t("To")}:</label>
                    {errors.end_date?.message && (
                      <p className="text-red-600">
                        {t(errors.end_date?.message)}
                      </p>
                    )}
                    <input
                      {...register("end_date", {
                        required: t("Feild is required"),
                      })}
                      type="date"
                      className="form-control"
                    />
                  </div>
                </div>
                <div className="row">
                  <Button
                    type="submit"
                    form="update-coupon-form"
                    className={`form-control ${
                      updateCouponLoading
                        ? "opacity-80 pointer-events-none"
                        : ""
                    } w-fit`}
                    style={{ width: "fit-content" }}
                  >
                    {!updateCouponLoading ? (
                      t("Submit")
                    ) : (
                      <div className="relative flex justify-center items-center">
                        {t("Loading")}...
                      </div>
                    )}
                  </Button>
                </div>
              </form>
            </div>
          </div>
        </div>
      ) : (
        <EmptyData emptyText={t("No Data")} />
      )}
    </>
  );
}
